module.exports = __webpack_public_path__ + "static/media/8033237638.c3894626.jpg";